<template>
    <div>
        <Dialog :initialFocus="chooseAreaButtonRef" as="div" class="relative z-100">

            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black/90" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out absolute "
                        enter-from="opacity-0 scale-95 bottom-full" enter-to="opacity-100 scale-100 bottom-[35%]"
                        leave="duration-200 ease-in absolute" leave-from="opacity-100 scale-100 bottom-[35%]"
                        leave-to="opacity-0 scale-95 bottom-full">
                        <DialogPanel
                            class=" w-[407px] max-w-md transform rounded-2xl bg-white p-6 text-start align-middle shadow-xl transition-all  h-[619px] max-h-[75vh]">
                            <a role="button" @click="cancel()" class="absolute md:-top-0 -top-10 md:-right-[8%] right-0 ">
                                <img src="../../assets/images/icons/ic-close-light.svg" width="21" height="21" />
                            </a>
                            <div class="h-full">
                                <section class="text-sm text-gray-500 h-full">
                                    <DialogTitle as="h3" class=" leading-6">
                                        <h5 class="text-dark-4 font-bold text-2xl flex flex-nowrap">{{t('modal.Pick_Location')}}</h5>
                                    </DialogTitle>
                                    <form name="areasForm"
                                        class="mt-2 flex flex-col justify-between h-[calc(100%-40px)]"
                                        @submit.prevent="chooseArea()">
                                        <div
                                            class="grid grid-cols-1 divide-y overflow-y-auto scrollbar-hide md:scrollbar-default max-h-[85%] h-[80%]  ">
                                            <div v-for="area in areasListData" :key="area.id">
                                                <default-radio class="py-3 " :name="area.name" :value="area.id"
                                                    v-model="areasForm.selectedArea" extra-classes="me-6"
                                                    :checked="areasForm.selectedArea == area.id">
                                                    {{ area.name }}
                                                </default-radio>
                                            </div>
                                        </div>
                                        <div class="max-h-[15%] h-[15%] flex flex-col justify-end">
                                            <primary-button type="submit"
                                                class=" w-full cursor-pointer font-medium text-base	"
                                                :disabled="!areasForm.selectedArea"
                                                :class="{ 'grayscale !text-dark-gray-7 !bg-light-gray-9 hover:bg-light-gray-9 hover:text-dark-gray-7': (!areasForm.selectedArea) }">
                                                {{t('buttons.Choose')}}
                                            </primary-button>

                                        </div>
                                    </form>
                                </section>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>

        <!-- loader -->
        <Loader :modalIsOpen="isLoading" :initFocusedRef="chooseAreaButtonRef" class="" :widthSM="true"></Loader>
    </div>

</template>
<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex"
import { numberOnly } from "@/common/Directives/numberOnly";
import Request from "@/common/Request"
import Response from "@/common/Response"

import DefaultRadio from "@/components/atoms/inputs/DefaultRadio";
import PrimaryButton from "@/components/atoms/buttons/PrimaryButton";
import Loader from "@/components/atoms/Loader";

import {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
} from '@headlessui/vue';

export default {
    name: "pick-area-modal",
    components: {
        Loader,
        DefaultRadio,
        PrimaryButton,
        Dialog,
        DialogTitle,
        DialogPanel,
        TransitionChild,

    },
    emits: ["cancel"],
    props: ['areasList'],

    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore()
        const isLoading = ref(false)
        const chooseAreaButtonRef = ref()
        const areasListData = ref([])
        const areasForm = ref({
            selectedArea: '',
        })

        const chooseArea = async function () {
            // isLoading.value = true
            new Request().get(`areas/${areasForm.value?.selectedArea}`).then((res) => {
                if (res?.data) {
                    let areaObj = res?.data.data
                    //update user area
                    store.commit("updateUserArea", areaObj)

                    // setTimeout(() => {
                    //     isLoading.value = false
                    // })

                    //cancel otp modal
                    setTimeout(() => {
                        emit('cancel')
                        window.location.reload()
                        new Response({ message: t('messages.area_updated') }).displaySuccess()
                    }, 0)

                } else {
                    isLoading.value = false
                }

            }, (err) => {
                new Response({ message: t('messages.Internal_Error') }).displayErrors()

                isLoading.value = false

            })
        }

        onMounted(() => {
            areasForm.value.selectedArea = store.getters.userArea?.id || ''
            if (props.areasList?.length == 0) {
                isLoading.value = true

                //get areas list
                new Request().get('areas').then((res) => {
                    if (res?.data && res.data.data) {
                        areasListData.value = res.data.data
                    }
                    setTimeout(() => {
                        isLoading.value = false
                    }, 300)

                }).catch((err) => {
                    setTimeout(() => {
                        isLoading.value = false
                    }, 300)
                }).then(() => {
                    setTimeout(() => {
                        isLoading.value = false
                    }, 300)
                })

            } else {
                areasListData.value = props.areasList
            }
        })

        return {
            t,
            isLoading,
            chooseAreaButtonRef,
            areasForm,
            areasListData,
            cancel() {
                //reset form
                areasForm.value = {
                    areaValue: '',
                }
                emit('cancel')
            },
            chooseArea,
        }
    }
}
</script>
<style scoped lang="scss">
.scrollbar-hide {
    @media (max-width: 768px) {
        &::-webkit-scrollbar {
            @apply w-0
        }
    }

}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.scrollbar-default::-webkit-scrollbar {

    width: 10px !important
}

.scrollbar-default {
    -ms-overflow-style: 10px;
    /* IE and Edge */
    scrollbar-width: 10px;
    /* Firefox */
}
</style>